import { defineMessages } from 'react-intl';

export default defineMessages({
  sideBarCourtMonitoringProvisionalClaims: {
    id: 'side_bar.court_monitoring_provisional_claims',
  },
  monitoringProvisionalClaimTitle: {
    id: 'monitoring_provisional_claim.title',
  },
  monitoringProvisionalClaimTableHeaderTitlesReference: {
    id: 'monitoring_provisional_claim.table_header_titles.reference',
  },
  monitoringProvisionalClaimTableHeaderTitlesCourtNumber: {
    id: 'monitoring_provisional_claim.table_header_titles.court_number',
  },
  monitoringProvisionalClaimTableHeaderTitlesCreationDate: {
    id: 'monitoring_provisional_claim.table_header_titles.creation_date',
  },
  monitoringProvisionalClaimTableHeaderTitlesStatus: {
    id: 'monitoring_provisional_claim.table_header_titles.status',
  },
  juridiction: {
    id:
      'legal_proceeding_page.judgement_add.procedure_information.jurisdiction.title',
  },
  rowsPerPage: {
    id: 'court_manager_page.assigned_claims_table.lines_per_page',
  },
  monitoringProvisionalClaimAddDrawerTitle: {
    id: 'monitoring_provisional_claim.add_drawer.title',
  },
  monitoringProvisionalClaimAddDrawerButtonTitle: {
    id: 'monitoring_provisional_claim.add_drawer.button_title',
  },
  monitoringProvisionalClaimAddDrawerProcedureLabel: {
    id: 'monitoring_provisional_claim.add_drawer.procedure_label',
  },
  monitoringProvisionalClaimAddDrawerDegreeJurisdiction: {
    id: 'monitoring_provisional_claim.add_drawer.degree_jurisdiction',
  },
  monitoringProvisionalClaimAddDrawerCourtNumber: {
    id: 'monitoring_provisional_claim.add_drawer.court_number',
  },
  monitoringProvisionalClaimAddDrawerJurisdiction: {
    id: 'monitoring_provisional_claim.add_drawer.jurisdiction',
  },
  monitoringProvisionalClaimAddDrawerHearingDate: {
    id: 'monitoring_provisional_claim.add_drawer.hearing_date',
  },
  monitoringProvisionalClaimAddDrawerLawyer: {
    id: 'monitoring_provisional_claim.add_drawer.lawyer',
  },
  courtFileNumberError: {
    id: 'legal_proceeding_page.number_field.error',
  },
  monitoringProvisionalClaimRecapTitle: {
    id: 'monitoring_provisional_claim.recap.title',
  },
  managerActionTitle: {
    id: 'action.title',
  },
  AssignExpertTitle: {
    id: 'drawer.monitoring_manager.assign_expert_title',
  },
  ProvisionalClaimRecapActionsPreopenClaim: {
    id: 'provisional_claim_recap_actions.preopen_claim',
  },
  ProvisionalClaimRecapActionsPreopenClaimDialogTitle: {
    id: 'provisional_claim_recap_actions.preopen_claim_dialog_title',
  },
  ProvisionalClaimRecapActionsPreopenClaimDialogContent: {
    id: 'provisional_claim_recap_actions.preopen_claim_dialog_content',
  },
  ProvisionalClaimRecapActionsPreopenClaimDialogConfirm: {
    id: 'provisional_claim_recap_actions.preopen_claim_dialog_confirm',
  },
  ProvisionalClaimRecapActionsPreopenClaimDialogCancel: {
    id: 'provisional_claim_recap_actions.preopen_claim_dialog_cancel',
  },
  ProvisionalClaimRecapActionsAddClaimNumber: {
    id: 'provisional_claim_recap_actions.add_claim_number',
  },
  ProvisionalClaimRecapDialogAddClaimNumberDialogTitle: {
    id: 'provisional_claim_recap_dialog.add_claim_Number_dialog_title',
  },
  ProvisionalClaimRecapDialogClaimNumberInput: {
    id: 'provisional_claim_recap_dialog.claim_number_input',
  },
  ProvisionalClaimRecapDialogToastErrorMessage: {
    id: 'provisional_claim_recap_dialog.toast_error_message',
  },
  ProvisionalClaimRecapClaimNumber: {
    id: 'provisional_claim_recap.claim_number',
  },
  ProvisionalClaimRecapActionsValidateLiaison: {
    id: 'provisional_claim_recap_actions.validate_liaison',
  },
  ProvisionalClaimRecapActionsRejectLiaison: {
    id: 'provisional_claim_recap_actions.reject_liaison',
  },
  ProvisionalClaimRecapActionsValidateLiaisonDialogContent: {
    id: 'provisional_claim_recap_actions.validate_liaison_dialog_content',
  },
  ProvisionalClaimRecapActionsRejectLiaisonDialogContent: {
    id: 'provisional_claim_recap_actions.reject_liaison_dialog_content',
  },
  ProvisionalClaimStatusPending: {
    id: 'provisional_claim_status.pending',
  },
  ProvisionalClaimStatusMapped: {
    id: 'provisional_claim_status.mapped',
  },
  InvitationLetter: {
    id: 'invitation_letter',
  },
  addVictim: {
    id: 'preopening_page.victim.add_victim',
  },
});
